<template>
    <Radar :chart-options="chartOptions" :chart-data="chartData" />
</template>

<script>

import { Radar } from 'vue-chartjs'
import {   Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  RadialLinearScale,
  LineElement,
 } from 'chart.js'

ChartJS.register(Title,
  Tooltip,
  Legend,
  PointElement,
  RadialLinearScale,
  LineElement)

/**
 * Exports a configured chart.js Pie chart 
 */
export default {
    name: 'RadarChart',
    components: { Radar },
    props: {
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object,
            required: false
        },
    },    
}
</script>
